import { useMutation } from '@tanstack/react-query'

import { disableScim } from '@src/api'
import { DefaultApiDisableScimRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useDisableScim = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiDisableScimRequest) =>
      disableScim(axiosInstance, params),
  })
}
